// extracted by mini-css-extract-plugin
module.exports = {"form":"explore_form__1yl20","width":"explore_width__1oaeA","text":"explore_text__1CxhY","iframe":"explore_iframe__1cfgq"};